import React from "react";
import "./app.css";
import Redirect from "./redirect/Redirect";
import { IntercomProvider } from "react-use-intercom";
import { environment, INTERCOM_APP_ID } from "../env-exports";
import { withCookieAuthenticator } from "halter-common-login";

function App() {
  return (
    <IntercomProvider appId={INTERCOM_APP_ID!}>
      <Redirect />
    </IntercomProvider>
  );
}

export default withCookieAuthenticator(App, { env: environment });
